import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import * as Global from 'src/app/global';
import { AuthService } from 'src/app/services/auth.service';
import { CustomService } from 'src/app/services/custom.service';
import { emailValidator } from 'src/app/validators/custom-form.validator';
import swal from 'sweetalert2';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  Global = Global;
  loginForm: FormGroup;
  forgotPasswordForm: FormGroup;
  roleDetails: {
    slug: string; role: string;
  } = { slug: 'guest', role: 'Guest', }

  @ViewChild('forgotPasswordModal') public forgotPasswordModal: ModalDirective;

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private toastr: ToastrService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private customService: CustomService
  ) {
    this.loginForm = formBuilder.group({
      email: [null, Validators.compose([Validators.required, Validators.email])],
      password: [null, Validators.compose([Validators.required])],
      rememberme: [null, Validators.compose([])],
    });

    this.forgotPasswordForm = formBuilder.group({
      email: [null, Validators.compose([Validators.required, emailValidator()])],
    });
  }

  ngOnInit() {
    setTimeout(() => {
      this.activatedRoute.params.subscribe((params: any) => {
        switch (params?.role) {
          case 'seller':
            this.roleDetails = { slug: "seller", role: "Seller", }
            break;

          case 'broker':
            this.roleDetails = { slug: "broker", role: "Facilator", }
            break;

          case 'buyer':
            this.roleDetails = { slug: "buyer", role: "Buyer", }
            break;

          default:
            this.customService.abortError(404);
            return;
        }
      })
    });
  }

  submit(event: any) {
    this.loginForm.markAllAsTouched();
    Global.scrollToQuery(".form-control.is-invalid");

    if (this.loginForm.valid) {
      event.target.classList.add('btn-loading');
      event.target.disabled = true;

      this.authService.userLogin({
        'role': this.roleDetails.slug,
        'email': this.loginForm.value.email ?? null,
        'password': this.loginForm.value.password ?? null,
      }).subscribe(res => {
        const data = res.data;
        if (res.status == 'success') {
          this.authService.userSuccessLogin({
            'token': data?.token ?? null,
            'user': data?.user ?? null,
          })
          if(data.disclaimer_text)
          {
           localStorage.setItem('teainntech-sidebar-minimized', '0');
           localStorage.setItem('disclaimer_text', data.disclaimer_text)
           localStorage.setItem('disclaimer_popup_open', '1');
          }
          else{
            localStorage.setItem('disclaimer_text', "")
            localStorage.setItem('disclaimer_popup_open', '0');
          }


          return;
        } else if (res.status == 'passwordexpired') {
          swal.fire({
            text: res.message,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Reset Password',
            cancelButtonText: 'Cancel',
          }).then((result) => {
            if (result.value) {
              this.initForgotPassword({ autoFillEmail: this.loginForm.value.email });
            }
          })
        } else if (res.status == 'otpverification') {
          this.router.navigate([`/otp-verification/user-login/${res.data.token}`]);
          this.toastr.success(res.message)
        } else if (res.status == 'val_error') {
          this.toastr.error(Global.getValidationMessage(data?.errors ?? []));
        } else {
          this.toastr.error(res.message);
        }

        event.target.classList.remove('btn-loading');
        event.target.disabled = false;
      }, err => {
        //this.toastr.error(Global.getServerErrorMessage(err));

        event.target.classList.remove('btn-loading');
        event.target.disabled = false;
      });
    }
  }

  /**
   * =========================
   * FORGOT PASSWORD FUNCTIONS
   * =========================
   */

  initForgotPassword({ autoFillEmail = <any>null } = {}) {
    this.cancelForgotPassword();
    this.forgotPasswordModal.show();

    if (autoFillEmail) {
      this.forgotPasswordForm.get('email')?.setValue(autoFillEmail);
    }
  }

  cancelForgotPassword() {
    this.forgotPasswordModal.hide();
    Global.resetForm(this.forgotPasswordForm)
  }

  submitForgotPassword(event: any) {
    this.forgotPasswordForm.markAllAsTouched();
    Global.scrollToQuery(".form-control.is-invalid");

    if (this.forgotPasswordForm.valid) {
      event.target.classList.add('btn-loading');
      event.target.disabled = true;

      this.authService.userForgotPassword({
        'email': this.forgotPasswordForm.value.email ?? null,
      }).subscribe(res => {
        const data = res.data;
        if (res.status == 'otpverification') {
          this.router.navigate([`/otp-verification/user-resetpassword/${res.data.token}`]);
          this.toastr.success(res.message)
        } else if (res.status == 'val_error') {
          this.toastr.error(Global.getValidationMessage(data?.errors ?? []));
        } else {
          this.toastr.error(res.message);
        }

        event.target.classList.remove('btn-loading');
        event.target.disabled = false;
      }, err => {
        // this.toastr.error(Global.getServerErrorMessage(err));

        event.target.classList.remove('btn-loading');
        event.target.disabled = false;
      });
    }
  }
}


